import React from 'react';
import {
  PhotoCameraOutlined as PhotoIcon,
  VideocamOutlined as VideoIcon,
  MicOutlined as AudioIcon,
  DescriptionOutlined as DocumentIcon,
  EmojiEmotionsOutlined as StickerIcon,
} from '@mui/icons-material';

const MESSAGE_TYPE_PREVIEW = {
  image: { Icon: PhotoIcon, labelKey: 'leads.lastMessagePhoto' },
  video: { Icon: VideoIcon, labelKey: 'leads.lastMessageVideo' },
  audio: { Icon: AudioIcon, labelKey: 'leads.lastMessageAudio' },
  document: { Icon: DocumentIcon, labelKey: 'leads.lastMessageDocument' },
  sticker: { Icon: StickerIcon, labelKey: 'leads.lastMessageSticker' },
};

// "7.66" (segundos, do processamento assíncrono da mídia) → "0:07".
export const formatDuration = (seconds) => {
  const totalSeconds = Math.round(seconds);
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;
  return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`;
};

// Áudio/vídeo só ganham `duration` depois do processamento assíncrono da mídia —
// enquanto isso não chega, ainda está processando (mesmo já sabendo o tipo).
export const isMediaProcessing = (messageType, durationSeconds) =>
  (messageType === 'audio' || messageType === 'video') && durationSeconds == null;

// null para 'text' (e tipos desconhecidos): quem chama deve renderizar o texto em si.
// Para áudio com duração já processada, mostra a duração (ex.: "0:07") em vez do
// rótulo genérico "Áudio" — replica o padrão do WhatsApp.
export const getMessageTypePreview = (messageType, t, durationSeconds) => {
  const preview = MESSAGE_TYPE_PREVIEW[messageType];
  if (!preview) return null;

  if (messageType === 'audio' && durationSeconds != null) {
    return { icon: <AudioIcon fontSize="small" />, label: formatDuration(durationSeconds) };
  }

  const { Icon, labelKey } = preview;
  return { icon: <Icon fontSize="small" />, label: t(labelKey) };
};
